var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { get } from 'lodash';
export var eventToSlice = function eventToSlice(event) {
  // tweak images to favour banner thumbnail first
  var images = event.images;
  var thumbnail = get(event, 'banner.thumbnail');

  if (thumbnail && thumbnail.url) {
    images.unshift({
      id: event.slug + "-thumbnail",
      image: thumbnail
    });
  }

  return __assign(__assign({}, event), {
    images: images,
    title: event.title || event.name,
    subtitle: event.subtitle,
    content: event.description,
    links: [{
      slug: "link-" + event.slug,
      url: event.path,
      label: 'View Event Details'
    }]
  });
};